'use strict';

const Enum = require('./enum');

/**
 * Defines entity types for activity feed
 *
 * @enum
 * @readonly
 */
const Entities = Object.create(Enum, {
  BRIDGE: { value: 'bridge', enumerable: true },
  CAMERA: { value: 'camera', enumerable: true },
  DOORBELL: { value: 'doorbell', enumerable: true },
  HOUSE: { value: 'house', enumerable: true },
  KEYPAD: { value: 'keypad', enumerable: true },
  LOCK: { value: 'lock', enumerable: true },
  USER: { value: 'user', enumerable: true },
});

exports.Entities = Entities;
